import getters from '~/store/modules/shared/userAgent/getters'
import mutations from '~/store/modules/shared/userAgent/mutations'
import state from '~/store/modules/shared/userAgent/state'
import { createModule } from '~/factories/store'

export default createModule({
  getters,
  mutations,
  state
})
